import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { capitalize, startCase } from 'lodash-es';

import styles from './SignupFormError.module.css';
import { TSignupErrorType } from '../../../hooks/useOffers/useOffers';
import { useSignupRouterUK } from '../../../hooks/useSignupRouter/useSignupRouterUK';
import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';
import { Button } from '../../Button/Button';

const SignupFormErrorUK = ({ error }: { error: TSignupErrorType }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { navigateSignup } = useSignupRouterUK();

  useEffect(() => {
    tracking.ampli.lendingDecisionErrored({
      'Error type': capitalize(startCase(error)),
      ...getAmplitudeDefaultEventProperties(),
    });
  }, []);

  const handleClick = async () => {
    setIsLoading(true);
    await navigateSignup({ route: 'applicant' });
    setIsLoading(false);
  };

  const getErrorData = () => {
    switch (error) {
      case 'check_directors_match_companies_house':
        return {
          heading: 'Do your details look right?',
          text: (
            <p>
              We weren’t able to run our checks - can you double check the
              details you gave? Then we’ll take another look.
            </p>
          ),
        };
      default:
        return {
          heading: 'We have experienced a technical error',
          text: (
            <p className={styles.content}>
              If you continue to see this error, please{' '}
              <a
                href="mailto:support@iwoca.co.uk"
                data-testid="email-link"
                target="_blank"
                rel="noreferrer"
              >
                email
              </a>{' '}
              or{' '}
              <a
                href="tel:02037780105"
                data-testid="call-link"
                target="_blank"
                rel="noreferrer"
              >
                call
              </a>{' '}
              our team.
            </p>
          ),
        };
    }
  };

  const modalContent = getErrorData();

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>{modalContent.heading}</h1>
      <div className={styles.content}>{modalContent.text}</div>
      <Button
        className={styles.backButton}
        loading={isLoading}
        onClick={handleClick}
      >
        Back
      </Button>
    </div>
  );
};

export default SignupFormErrorUK;
